import React from "react";
import { Grid, Typography } from "@material-ui/core";

const TargetBreakDown = ({ avgNextMonthNewAds, avgNextMonthRenewAds }) => {
  return (
    <Grid container className="target-breakdown-section my-8">
      <Typography variant="body2" className="font-bold">
        Daily Target
      </Typography>
      <Grid item container className="justify-between px-8">
        <Typography variant="caption">
          <b>New Ads:</b> {avgNextMonthNewAds}
        </Typography>
        <Typography variant="caption">
          <b>Renewals:</b> {avgNextMonthRenewAds}
        </Typography>
      </Grid>
    </Grid>
  );
};

export default TargetBreakDown;
